// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1dCll","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3yQU_","obliqueLine":"membershipbadge_obliqueLine__vpoAQ"};